const BasicInfoCardStyles = {
  BasicInfoCard: {
    background: "linear-gradient(108deg, #FFF 80.85%, #F8F9FF 145.84%)",
    display: "flex",
    justifyContent: "space-between",
    border: "1px solid #C9E1EC",
    borderRadius: "10px",
    "@media (max-width: 399px)": {
      flexDirection: "column",
    },
    "@media (min-width: 399px) and (max-width: 799px)": {
      flexDirection: "column",
    },
    "@media (min-width: 799px) and (max-width: 1300px)": {
      flexDirection: "column",
    },
  },

  status: {
    display: "flex",
    gap: "6.5px",
    maxHeight: "18px",
    marginTop: "10.79px",
    alignItems: "center",
  },
  statusText: {
    color: "#56CF66",
    fontSize: "16px",
    fontWeight: 400,
    fontFamily: "Noto Sans",
  },
  head: {
    fontWeight: "300",
    fontFamily: "Noto sans",
    color: "#1D252B",
    display: "flex",
    alignItems: "center",
    fontStyle: "normal",
    whiteSpace: "pre",
    "@media (max-width: 789px)": {
      fontSize: "14px",
    },
  },
  content: {
    fontWeight: "400",
    fontFamily: "Noto sans",
    color: "#1D252B",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  drawer: {
    display: "flex",
    justifyContent: "space-between",
    position: "sticky",
    top: 0,
    zIndex: 99,
    padding: "20px 15px",
    img: {
      cursor: "pointer",
    },
    "@media (min-width:360px) and (max-width:599px)": {
      paddingBottom: "0px",
      height: "60px",
      alignItems: "center",
      padding: "19px 20px 19px 20px",
      border: "1px solid #D8D8D8",
      boxShadow: "0px 6px 30px 0px #00000014",
    },
  },
};

export default BasicInfoCardStyles;
